// SyncFusionDateTimePicker.jsx
import React from "react";
import { DateTimePickerComponent, DatePickerComponent } from "@syncfusion/ej2-react-calendars";

const SyncFusionDateTimePicker = ({
  id,
  value,
  onChange,
  placeholder,
  min,
  max,
  width = "100%",
  step = 10,
  localUnderMaintenace
}) => {
  const isOnlyDate = id === "onlyDate";

  if (isOnlyDate) {
    return (
      <DatePickerComponent
        id={id}
        value={value}
        change={(e) => {
          if (e.value instanceof Date) {
            onChange(e.value);
          } else {
            onChange(null);
          }
        }}
        format="dd/MM/yyyy"
        locale="pt"
        placeholder={placeholder}
        min={min}
        max={max}
        width={width}
        strictMode={true}
        disabled={localUnderMaintenace == "S"}
      />
    );
  }

  return (
    <DateTimePickerComponent
      id={id}
      value={value}
      change={(e) => {
        if (e.value instanceof Date) {
          onChange(e.value);
        } else {
          onChange(null); // fallback
        }
      }}
      format="dd/MM/yyyy HH:mm:ss"
      timeFormat="HH:mm:ss"
      locale="pt"
      placeholder={placeholder}
      min={min}
      max={max}
      step={step}
      width={width}
      strictMode={true}
      disabled={localUnderMaintenace == "S"}
    />
  );
};

export default SyncFusionDateTimePicker;
